import React from 'react';
import NotificationContainer from '../../components/NotificationContainer';

const RecordarNotificacion = () => (
  <div className="c-sii-home">
    <NotificationContainer
      icon="okCircleOutline"
      iconColor="green"
      title="Contraseña temporal enviada correctamente"
      description="La próxima vez que acceda a la plataforma deberá cambiar la contraseña."
    />
  </div>
);

export default RecordarNotificacion;
